import {
    SET_HAS_APP_RECEIVED,
    SET_HAS_HEADER_RECEIVED, SET_PPID, SET_HEADER_VALUES, SET_MODEL,
    SET_OPERATE_VER, SET_SAME_MENU_ITEM_CLICK, SET_CURRENT_PLC,
    // @ test user credentials
    SET_LOGIN_SUCCESS, SET_LOGOUT, SET_CHECK_SESSION,
    SET_SOFC_CONFIG,
    SET_USER_ARRAY, SET_IS_WARNING_AL
} from '../constants/actions';

export const setHasHeaderReceived = (hasHeaderReceived) => ({
    type: SET_HAS_HEADER_RECEIVED,
    hasHeaderReceived: hasHeaderReceived
});

export const setPPID = (ppid) => ({
    type: SET_PPID,
    ppid: ppid
});

export const setHasAppReceived = (hasAppReceived) => ({
    type: SET_HAS_APP_RECEIVED,
    hasAppReceived: hasAppReceived
});

export const setHeaderValues = (headerValues) => ({
    type: SET_HEADER_VALUES,
    headerValues: headerValues
});

export const setModel = (model) => ({
    type: SET_MODEL,
    model: model
});

// ^ SOFC_HMI: header추가
export const setOperateVersion = (operateVersion) => ({
    type : SET_OPERATE_VER,
    operateVersion : operateVersion
});

export const setSameMenuItemClick = (sameMenuItemClick) => ({
    type : SET_SAME_MENU_ITEM_CLICK,
    sameMenuItemClick : sameMenuItemClick
});

export const setCurrentPLC = (currentPLC) => ({
    type : SET_CURRENT_PLC,
    currentPLC : currentPLC
});

// @ user credential 기능 테스트
export const setLoginSuccess = (user) => ({
    type : SET_LOGIN_SUCCESS,
    user : user,
});

export const setLogout = () => ({
    type :SET_LOGOUT,
});

export const setCheckSession = (user) => ({
    type : SET_CHECK_SESSION,
    user : user
});

export const setSofcConfig = (sofcConfig) => ({
    type : SET_SOFC_CONFIG,
    sofcConfig : sofcConfig
});


export const setUserArray = (userArray) => ({
    type: SET_USER_ARRAY,
    userArray: userArray
});

// [UPDATE] Shutdown Ack -> change alarm ack
export const setIsWarningAL = (isWarningAL) => ({
    type : SET_IS_WARNING_AL,
    isWarningAL : isWarningAL
});